import React from 'react';
import PropTypes from 'prop-types';

const IframeVideo360 = ({ src, className }) => (
  <iframe
    src={src}
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    className={className}
    allowFullScreen></iframe>

);

IframeVideo360.propTypes = {
  src: PropTypes.string.isRequired,
};

export default IframeVideo360;
